import { NgClass } from '@angular/common';
import { AfterViewInit, Component, Input, inject } from '@angular/core';

import { TrackingService, TrackingType, trackingConstants } from '@frontend/sports/tracking/feature';
import { DsButton } from '@frontend/ui/button';

import { ActiveModal } from '../common/modal-ref';
import { IConfirmationDialogButton, IConfirmationDialogComponentModel } from './confirmation-dialog.model';

@Component({
    selector: 'ms-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    imports: [NgClass, DsButton],
})
export class ConfirmationDialogComponent implements AfterViewInit {
    private activeModal = inject(ActiveModal);
    private trackingService = inject(TrackingService);

    @Input() contentModel: IConfirmationDialogComponentModel;

    get isDesignSystem(): boolean {
        return this.contentModel.buttons.every((b) => b.buttonConfig);
    }

    ngAfterViewInit(): void {
        if (this.contentModel.tracking) {
            switch (this.contentModel.tracking.type) {
                case TrackingType.PageName:
                    this.trackingService.track(this.contentModel.tracking.name, this.contentModel.tracking.data || {});
                    break;
                case TrackingType.Referring:
                    this.trackingService.update({ [trackingConstants.PAGE_REFERRING_ACTION]: this.contentModel.tracking.name });
                    break;
            }
        }
    }

    handleClick(button: IConfirmationDialogButton): void {
        this.activeModal.close(button.buttonType);
    }
}
